package dev.bitspittle.droidconSf24.pages.sections.conclusion

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun Community2Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/conclusion/Community2.md", mapOf("styles" to listOf("accented-subheaders")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("community") }) {
                org.jetbrains.compose.web.dom.Text("Community")
            }
            org.jetbrains.compose.web.dom.H3(attrs = { id("stevdza-san") }) {
                com.varabyte.kobweb.compose.dom.GenericTag("span", "data-id=\"name\"") {
                    org.jetbrains.compose.web.dom.Text("Stevdza-san")
                }
            }
            com.varabyte.kobweb.compose.dom.GenericTag("iframe", "width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/F5B-CxJTKlg\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" allowfullscreen=\"\"")
        }
    }
}
